import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'

// Library `vue2-google-maps` is moved to assets directory due to package's
// incorrect webpack configuration and need of tweak the `gmap-marker` component
import * as VueGoogleMaps from '@/assets/js/vue2-google-maps/src/main'
import GmapCluster from '@/assets/js/vue2-google-maps/src/components/cluster'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store/'
import '@/register-sw'

Vue.config.productionTip = false

Vue.use(VueYouTubeEmbed)
Vue.use(VueGoogleMaps, {
  load: { key: process.env.VUE_APP_MAP_KEY, libraries: 'places' }
})
Vue.component('GmapCluster', GmapCluster)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js